defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/TabsSwitch',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'Shared/Framework/Ensighten/Scripts/Ensighten',
  ],
  function (m, Ensighten) {
    var TabsSwitch = {
      controller: function ({ controller }) {
        Object.assign(this, controller);

        this.selectTab = function (tab) {
          return function () {
            Ensighten.pushGaEvent('spil_sammen', 'cta_click', tab.label?.toLowerCase());
            this.activeTabValue(tab.value);
            this.onTabChange?.();
          }.bind(this);
        }.bind(this);
      },
      view: function (controller) {
        const className = (tab) => {
          let name = '';

          if (controller.activeTabValue() === tab.value) {
            name += ' tab-switch--selected';
          }

          if (tab.inactive) {
            name += ' tab-switch--inactive';
          }

          return name;
        };
        return m('.play-together__tabs-switch', controller.tabsSwitch.map(function (tab) {
          return m('.tab-switch', {
            class: className(tab),
            onclick: controller.selectTab(tab)
          }, tab.label);
        }));
      }
    };

    // Public functions:
    return TabsSwitch;
  });
